import { __rest } from "tslib";
import React from 'react';
import { Portal } from '../../Portal/Portal';
import { usePlotContext } from '../context';
import { CursorPlugin } from './CursorPlugin';
import { SeriesTable } from '../../Graph/GraphTooltip/SeriesTable';
import { FieldType, formattedValueToString, getDisplayProcessor, getFieldDisplayName, } from '@grafana/data';
import { TooltipContainer } from '../../Chart/TooltipContainer';
import { useGraphNGContext } from '../../GraphNG/hooks';
/**
 * @alpha
 */
export var TooltipPlugin = function (_a) {
    var _b = _a.mode, mode = _b === void 0 ? 'single' : _b, timeZone = _a.timeZone, otherProps = __rest(_a, ["mode", "timeZone"]);
    var pluginId = 'PlotTooltip';
    var plotContext = usePlotContext();
    var graphContext = useGraphNGContext();
    var xField = graphContext.getXAxisField();
    if (!xField) {
        return null;
    }
    var xFieldFmt = xField.display || getDisplayProcessor({ field: xField, timeZone: timeZone });
    return (React.createElement(CursorPlugin, { id: pluginId }, function (_a) {
        var _b, _c;
        var focusedSeriesIdx = _a.focusedSeriesIdx, focusedPointIdx = _a.focusedPointIdx, coords = _a.coords;
        if (!plotContext.getPlotInstance()) {
            return null;
        }
        var tooltip = null;
        // when no no cursor interaction
        if (focusedPointIdx === null) {
            return null;
        }
        var xVal = xFieldFmt(xField.values.get(focusedPointIdx)).text;
        // origin field/frame indexes for inspecting the data
        var originFieldIndex = focusedSeriesIdx
            ? graphContext.mapSeriesIndexToDataFrameFieldIndex(focusedSeriesIdx)
            : null;
        // when interacting with a point in single mode
        if (mode === 'single' && originFieldIndex !== null) {
            var field = otherProps.data[originFieldIndex.frameIndex].fields[originFieldIndex.fieldIndex];
            var plotSeries = plotContext.getSeries();
            var fieldFmt = field.display || getDisplayProcessor({ field: field, timeZone: timeZone });
            var value = fieldFmt(plotContext.data[focusedSeriesIdx][focusedPointIdx]);
            tooltip = (React.createElement(SeriesTable, { series: [
                    {
                        // TODO: align with uPlot typings
                        color: plotSeries[focusedSeriesIdx].stroke(),
                        label: getFieldDisplayName(field, otherProps.data[originFieldIndex.frameIndex]),
                        value: value ? formattedValueToString(value) : null,
                    },
                ], timestamp: xVal }));
        }
        if (mode === 'multi') {
            var series = [];
            var plotSeries = plotContext.getSeries();
            for (var i = 0; i < plotSeries.length; i++) {
                var dataFrameFieldIndex = graphContext.mapSeriesIndexToDataFrameFieldIndex(i);
                var frame = otherProps.data[dataFrameFieldIndex.frameIndex];
                var field = otherProps.data[dataFrameFieldIndex.frameIndex].fields[dataFrameFieldIndex.fieldIndex];
                if (field === xField ||
                    field.type === FieldType.time ||
                    field.type !== FieldType.number || ((_c = (_b = field.config.custom) === null || _b === void 0 ? void 0 : _b.hideFrom) === null || _c === void 0 ? void 0 : _c.tooltip)) {
                    continue;
                }
                var value = field.display(plotContext.data[i][focusedPointIdx]);
                series.push({
                    // TODO: align with uPlot typings
                    color: plotSeries[i].stroke(),
                    label: getFieldDisplayName(field, frame),
                    value: value ? formattedValueToString(value) : null,
                    isActive: originFieldIndex
                        ? dataFrameFieldIndex.frameIndex === originFieldIndex.frameIndex &&
                            dataFrameFieldIndex.fieldIndex === originFieldIndex.fieldIndex
                        : false,
                });
            }
            tooltip = React.createElement(SeriesTable, { series: series, timestamp: xVal });
        }
        if (!tooltip) {
            return null;
        }
        return (React.createElement(Portal, null,
            React.createElement(TooltipContainer, { position: { x: coords.viewport.x, y: coords.viewport.y }, offset: { x: 10, y: 10 } }, tooltip)));
    }));
};
//# sourceMappingURL=TooltipPlugin.js.map